module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-mobile@2x-87fb869463f1670187cc21cc8075c13d.jpg";